module.exports = __webpack_public_path__ + "static/media/amex.66a7f02b.svg";